export const Statuses = Object.freeze({
  Idle: 'Idle',
  Pending: 'Pending',
  Resolved: 'Resolved',
  Rejected: 'Rejected'
});

export const isLoading = status =>
  status === Statuses.Idle || status === Statuses.Pending;
export const isResolved = status => status === Statuses.Resolved;
export const isRejected = status => status === Statuses.Rejected;
